import { authHeader } from '../helpers/authHeader';
import { handleAxiosResponse, api_base_url, axiosInstance } from '../services/common.services';
import { handleServiceRequest } from '../services/handleServiceRequest';
import NotificationService from "./NotificationService";

const baseUrl = `/api/message-templates`;

export class EmailTemplateModel {
    emailMessageTemplateId: number;
    templateName: string;
    description: string;
    fromName: string;
    replyToName: string;
    replyToAddress: string;
    subject: string;
    body: string;
}

export class SMSTemplateModel {
    smsMessageTemplateId: number;
    templateName: string;
    description: string;
    messageText: string;
}

export const messageTemplateService = {
    getEmailTemplates() {
        const object = {
            url: `${baseUrl}/email`,
            customErrorMessage: `Failed to get email templates`,
        };
        return handleServiceRequest.get(object);
    },
    getSMSTemplates() {
        const object = {
            url: `${baseUrl}/sms`,
            customErrorMessage: `Failed to get sms templates`,
        };
        return handleServiceRequest.get(object);
    },
    getBothTemplates() {
        const calls: Promise<any>[] = [];
        calls.push(this.getSMSTemplates())
        calls.push(this.getEmailTemplates())
        return Promise.all(calls);
    },
    getEmailTemplateById(templateId: number) {
        const object = {
            url: `${baseUrl}/email/${templateId}`,
            customErrorMessage: `Failed to get email template id: ${templateId}`,
        };
        return handleServiceRequest.get(object);
    },
    getSMSTemplateById(templateId: number) {
        const object = {
            url: `${baseUrl}/sms/${templateId}`,
            customErrorMessage: `Failed to get sms template id: ${templateId}`,
        };
        return handleServiceRequest.get(object);
    },
    createEmailTemplate(postBody: EmailTemplateModel) {
        const object = {
            url: `${baseUrl}/email`,
            customErrorMessage: `Failed to create email template`,
            postBody: postBody
        };
        return handleServiceRequest.post(object);
    },
    updateEmailTemplate(postBody: EmailTemplateModel) {
        const object = {
            url: `${baseUrl}/email/${postBody.emailMessageTemplateId}`,
            customErrorMessage: `Failed to update email template`,
            postBody: postBody
        };
        return handleServiceRequest.put(object);
    },
    createSMSTemplate(postBody: SMSTemplateModel) {
        const object = {
            url: `${baseUrl}/sms`,
            customErrorMessage: `Failed to create sms template`,
            postBody: postBody
        };
        return handleServiceRequest.post(object);
    },
    updateSMSTemplate(postBody: SMSTemplateModel) {
        const object = {
            url: `${baseUrl}/sms/${postBody.smsMessageTemplateId}`,
            customErrorMessage: `Failed to update sms template`,
            postBody: postBody
        };
        return handleServiceRequest.put(object);
    },
    deleteEmailTemplate(templateId: number) {
        const getObject = {
            url: `${baseUrl}/email/${templateId}`,
            customErrorMessage: `Failed to delete email template ${templateId}`

        };
        return handleServiceRequest.deleteItem(getObject);
    },
    deleteSMSTemplate(templateId: number) {
        const getObject = {
            url: `${baseUrl}/sms/${templateId}`,
            customErrorMessage: `Failed to delete sms template ${templateId}`

        };
        return handleServiceRequest.deleteItem(getObject);
    },
};